<template>
  <div class="dropdown-menu" :class="[showDatePickerflag ? 'dropdown-menu-datepicker' : '']">
    <!-- date filter main button start -->
    <MdButton data-qa-id="btn-selected-label" textalign="center" variant="ghost" ref="menuButton"  @mouseup="showHideDropdown" :disabled = "isBlur"
    :class="componentName === 'earningsreport' ? 'earningReportButton' : 'dashboardButton'">
      <MdIconCalendar class="calendarIcon" color="blue-duck--500" slot="icon-start"/>
      <span v-if="selectedOptionDashboard">
        <span ref="datepickerTextRef" :class="componentName === 'earningsreport' ? 'earningReportText': ''" > 
          {{$t(`pages.dashboard.components.dateSelectDropdown.${selectedOptionDashboard.label}`) }} 
        </span>
        <slot name="dropdownMenuIcon" v-if="isSelected(selectedOptionDashboard.label)"></slot>
      </span>
      <span ref="datepickerEarningTextRef" :class="componentName === 'earningsreport' ? 'earningReportText': ''" v-else>
        {{ selectedText }}
      </span>
      <MdIconArrowCaret class="arrowIcon" ref="datepickerArrowSvgRef" :rotate="!toggle ? 'down' : 'up'" color="blue-duck--500" as="button" />
    </MdButton>
    <!-- date filter main button end -->

    <!-- date filter list start-->
    <div v-show="toggle" class="dropdown-menu-wrapper">
      <ul v-show="toggle" data-qa-id="show-list-array" class="dropdown-menu__list"
        :class="[componentName === 'earningsreport' ? 'dropdown-menu__daterange' : 'dropdown-menu__dashboard']">
        <li class="dropdown-menu__list__item" v-for="option in options" :data-qa-id="'list-' + option.label"
          :key="option.label"
          :class="[{ 'selected': isSelected(option.label || option) }, 'dropdown-menu__daterange__option']"
          @click="onChange(option)">
          <template v-if="option.label">
            <span class="dropdown-menu__daterange__option__label selectedSpan">{{
              $t(`pages.dashboard.components.dateSelectDropdown.${option.label}`) }}</span>
            <span class="dropdown-menu__daterange__option__value selectedSpan">{{ selectedDateRange(option.label) }}</span>
          </template>
          <template v-else-if="option.label">
            {{ $t(`pages.dashboard.components.dateSelectDropdown.${option.label}`) }}
            <slot name="dropdownMenuIcon" v-if="isSelected(option.label)"></slot>
          </template>
          <template v-else>
            {{ option }}
            <slot name="dropdownMenuIcon" v-if="isSelected(option)"></slot>
          </template>
        </li>
        <li  v-if="componentName === 'earningsreport'" class="dropdown-menu__list__item dropdown-menu__daterange__option" :class="[{'selected': isSelected('custom_dates')}]" @click="onChange({label: 'custom_dates'})"><elementDatePicker @update:calendar="emitUpdateDateValue" :selected-option="selectedText" @show:select-range="changeMenuText" @show:last-selected="showLastSelected"/></li>
      </ul>
    </div>
    <!-- date filter list end -->
  </div>

  <section class="dateRangeOverlay" v-if="toggle">
    <button class="crossBtn">
       <span class="crossIcon"/>
    </button>
    <ul data-qa-id="show-mobile-list-array" class="dateRangeOverlayInner">
      <li v-for="option in options" data-qa-id="option.label" :key="option.label" class="dateRangeOverlayListOption" :class="[{ 'selected': isSelected(option.label || option) }]" @click="onChange(option)">
        <span class="dateRangeOverlayListOptionLabel selectedSpan">{{
          $t(`pages.dashboard.components.dateSelectDropdown.${option.label}`) }}</span>
        <span class="dateRangeOverlayListOptionValue selectedSpan">{{ selectedDateRange(option.label) }}</span>
      </li>
      <li v-if="componentName === 'earningsreport'" data-qa-id="list-custom-dates" key="custom_dates" class="dateRangeOverlayListOption dateRangeCustomDates" :class="[{ 'selected': isSelected('custom_dates') }]" @click="onChange({label: 'custom_dates'})">{{ earningsDateRangeSelected ? earningsDateRangeSelected : 'Custom dates' }}</li>
      </ul>
  </section>
  <section class="datePickerOverlay" v-if="showDatePickerflag">
    <elementDatePicker isMobile @update:calendar="emitUpdateDateValue" :selected-option="selectedText" @show:select-range="changeMenuText" @show:last-selected="showLastSelected"/>
  </section>
</template>

<script>
import { isEqual } from 'lodash'
import i18n from 'src/assets/i18n/i18n'
import { ref, onMounted, computed, onUnmounted, watch } from 'vue'
import Misc from '../../../utils/helper/misc'
import { useStore } from 'vuex'
import elementDatePicker from 'src/components/form/element-date-range'
import { MdButton, MdIconArrowCaret, MdIconCalendar } from '@antiqua-dls/vue-components'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: [String, Number],
      required: true
    },
    componentName: {
      type: String,
      default: '',
      required: true
    },
    isBlur: {
      type: Boolean,
      default: false
    }
  },
  components: {
    elementDatePicker,
    MdIconArrowCaret,
    MdButton,
    MdIconCalendar
  },
  emits: ['fou-dropdown-menu:change', 'fou-dropdown-menu:selectedValue', 'show:date-picker'],

  setup(props, { emit }) {
    const { t } = i18n().global
    const store = useStore()
    const toggle = ref(false)
    const menuButton = ref(null)
    const datepickerIconRef = ref(null)
    const datepickerTextRef = ref(null)
    const datepickerEarningTextRef = ref(null)
    const datepickerArrowRef = ref(null)
    const datepickerArrowSvgRef = ref(null)
    const selectedOption = ref('select_dates');
    const dateRange = ref(null)
    const showDatePicker = ref(false);
    const isMobile = ref(true)
    const selectedText = ref('Select dates')

    const showDatePickerflag = computed(() => store?.getters['salesReport/getDateCalendar'])
    const earningsDateRangeSelected = computed(() => store?.getters['salesReport/getDateRangeDropdown'])
    const finalSelected = computed(() => store?.getters['salesReport/getSelectedOption'])
    const getViewedFromReportBtn = computed(() => store?.getters['dashboard/getViewedFromReportBtn'])

    const selectedOptionDashboard = computed(() => props.options.find(
      (option) => isEqual(option.value, props.selectedValue))
    )

    const emitUpdateDateValue = (value) => {
      emit('fou-dropdown-menu:change', value)
      toggle.value = false
      selectedOption.value = ''
    }

    const currentOptionSelection = () => {
      if (selectedOption.value) {
        selectedText.value = t(`pages.dashboard.components.dateSelectDropdown.${selectedOption.value}`)
      }
    }

    const currentDateRangeSelection = () => {
      if (!earningsDateRangeSelected.value) return;
      selectedText.value = earningsDateRangeSelected.value
    }

    const startofMonth = () => {
      const dt = new Date()
      const currentDate = new Date(dt.getFullYear(), dt.getMonth(), 1)

      return {
        startDate: Misc.formatDate(new Date(dt), 'en', 'MMM D'),
        endDate: Misc.formatDate(new Date(currentDate), 'en', 'MMM D'),
        payloadFormatStartDate: Misc.formatDate(new Date(currentDate), 'en', 'YYYY-MM-DD'),
        payloadFormatEndDate: Misc.formatDate(new Date(dt), 'en', 'YYYY-MM-DD')
      }
    }

    const getYear = () => {
      const dt = new Date();
      const currentDate = new Date(dt.getFullYear(), 0, 1);

      return {
        startDate: Misc.formatDate(new Date(dt), 'en', 'MMM D'),
        endDate: Misc.formatDate(new Date(currentDate), 'en', 'MMM D'),
        payloadFormatStartDate: Misc.formatDate(new Date(currentDate), 'en', 'YYYY-MM-DD'),
        payloadFormatEndDate: Misc.formatDate(new Date(dt), 'en', 'YYYY-MM-DD')
      }
    }

    const getLastMonth = () => {
      const today = new Date();
      const lastMonth = new Date(today);
      lastMonth.setDate(1);
      lastMonth.setDate(0);
      const lastMonthStartDate = new Date(lastMonth);
      lastMonthStartDate.setDate(1);
      const lastMonthEndDate = new Date(lastMonth);

      return {
        startDate: Misc.formatDate(lastMonthStartDate, 'en', 'MMM D'),
        endDate: Misc.formatDate(lastMonthEndDate, 'en', 'MMM D'),
        payloadFormatStartDate: Misc.formatDate(lastMonthStartDate, 'en', 'YYYY-MM-DD'),
        payloadFormatEndDate: Misc.formatDate(lastMonthEndDate, 'en', 'YYYY-MM-DD'),
      }
    }

    const getQuarter = (value) => {
      let today = new Date(),
        quarter = Math.floor((today.getMonth() / 3)),
        startDate,
        endDate;

      if (value === 'previous') {
        startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
        endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
      }

      if (value === 'current') {
        startDate = new Date(today.getFullYear(), quarter * 3, 1);
        endDate = new Date();
      }

      return {
        startDate: Misc.formatDate(new Date(startDate), 'en', 'MMM D'),
        endDate: Misc.formatDate(new Date(endDate), 'en', 'MMM D'),
        payloadFormatStartDate: Misc.formatDate(new Date(startDate), 'en', 'YYYY-MM-DD'),
        payloadFormatEndDate: Misc.formatDate(new Date(endDate), 'en', 'YYYY-MM-DD')
      };

    }

    const getLastYear = () => {
      const lastyear = new Date(new Date().getFullYear() - 1, 0, 1);
      const start = (new Date(lastyear.getFullYear(), 0, 1));
      const end = (new Date(lastyear.getFullYear(), 11, 31));
      return {
        startDate: Misc.formatDate(new Date(start), 'en', 'MMM, YYYY'),
        endDate: Misc.formatDate(new Date(end), 'en', 'MMM, YYYY'),
        payloadFormatStartDate: Misc.formatDate(new Date(start), 'en', 'YYYY-MM-DD'),
        payloadFormatEndDate: Misc.formatDate(new Date(end), 'en', 'YYYY-MM-DD')
      }
    }

    const selectedDateRange = (option) => {
      if (option === 'this_month') {
        const formattedDate = startofMonth()
        return `${formattedDate.endDate} - Today`
      }
      if (option === 'this_quarter') {
        const formattedDate = getQuarter('current')
        return `${formattedDate.startDate} - Today`
      }
      if (option === 'this_year') {
        const formattedDate = getYear()
        return `${formattedDate.endDate} - Today`
      }
      if (option === 'last_month') {
        const formattedDate = getLastMonth()
        return `${formattedDate.startDate} - ${formattedDate.endDate}`
      }
      if (option === 'last_quarter') {
        const formattedDate = getQuarter('previous')
        return `${formattedDate.startDate} - ${formattedDate.endDate}`
      }
      if (option === 'last_year') {
        const formattedDate = getLastYear()
        return `${formattedDate.startDate} - ${formattedDate.endDate}`
      }
    }

    const onChange = (selected) => {
      if (selectedOptionDashboard.value?.value) {
        if (selectedOptionDashboard.value.value === selected.value) return
        showHideDropdown()
        emit('fou-dropdown-menu:change', selected.value)
        return;
      }

      if (selectedOption.value === selected.label) {
        return;
      }

      if (selected.label === 'this_month') {
        dateRange.value = startofMonth()
      }

      if (selected.label === 'this_quarter') {
        dateRange.value = getQuarter('current')
      }

      if (selected.label === 'this_year') {
        dateRange.value = getYear()
      }

      if (selected.label === 'last_month') {
        dateRange.value = getLastMonth()
      }

      if (selected.label === 'last_quarter') {
        dateRange.value = getQuarter('previous')
      }

      if (selected.label === 'last_year') {
        dateRange.value = getLastYear()
      }

      selectedOption.value = selected.label;
      if (selected.label === 'custom_dates') {
        selectedOption.value = 'select_range'
        showDatePicker.value = true
        store.commit('salesReport/showDatePicker', showDatePicker.value)
        return
      }
      store.commit('salesReport/setDateRangeDropdown', '')
      emit('fou-dropdown-menu:change', { startDate: dateRange.value?.payloadFormatStartDate, endDate: dateRange.value?.payloadFormatEndDate, selected: selected.label })
      toggle.value = false
    }

    const showLastSelected = () => {
      selectedText.value = getSelectedText()
      showDatePicker.value = false
      store.commit('salesReport/showDatePicker', showDatePicker.value)
    }
    const changeMenuText = () => {
      selectedText.value = 'Select range'
    }

    const handleClickOutside = (event) => {
      const dateFilterButtonContainer = [menuButton.value, datepickerTextRef.value, datepickerEarningTextRef.value, datepickerArrowRef.value, datepickerArrowSvgRef.value];
      const checkDateFilterButtonClick = dateFilterButtonContainer.includes(event.target);
      if (toggle.value && !checkDateFilterButtonClick && !showDatePicker.value) {
        toggle.value = false
      }
    }

    const getSelectedText = () => {
      let dropdownOption = props.options.find(option => option.label === finalSelected.value)
      if (dropdownOption?.label) {
        return t(`pages.dashboard.components.dateSelectDropdown.${finalSelected.value}`)
      }
      return finalSelected.value
    }

    const showHideDropdown = () => {
      if(props.isBlur) return
      if (showDatePickerflag.value) {
        toggle.value = false
        store.commit('salesReport/showDatePicker', false)
        selectedText.value = getSelectedText()
        return
      }
      toggle.value = !toggle.value;
    }

    const isSelected = label => (
      (label === (selectedOptionDashboard.value?.label || selectedOption.value) || label === finalSelected.value) && (selectedText.value !== 'Select range')
    ) || (selectedText.value === earningsDateRangeSelected.value || selectedText.value === 'Select range') && label === 'custom_dates';
    
    watch(
      () => selectedOption.value,
      (newValue) => {
        currentOptionSelection()
      }
    )
    watch(
      () => earningsDateRangeSelected.value,
      (newValue) => {
        currentDateRangeSelection()
      }
    )

    onMounted(() => {
      window.addEventListener('click', handleClickOutside);
      if (getViewedFromReportBtn.value) {
        selectedOption.value = finalSelected.value
      } 
      else {
        currentOptionSelection()
      }
    })

    onUnmounted(() => {
      store.commit('salesReport/setDateRangeDropdown', '')
      window.removeEventListener('click', handleClickOutside);
    })

    return {
      isMobile,
      t,
      toggle,
      elementDatePicker,
      menuButton,
      datepickerIconRef,
      datepickerTextRef,
      datepickerEarningTextRef,
      datepickerArrowRef,
      datepickerArrowSvgRef,
      selectedOption,
      dateRange,
      showDatePicker,
      selectedText,
      showDatePickerflag,
      earningsDateRangeSelected,
      finalSelected,
      selectedOptionDashboard,
      showLastSelected,
      changeMenuText,
      emitUpdateDateValue,
      currentOptionSelection,
      currentDateRangeSelection,
      startofMonth,
      getYear,
      getLastMonth,
      getQuarter,
      getLastYear,
      selectedDateRange,
      onChange,
      handleClickOutside,
      getSelectedText,
      showHideDropdown,
      isSelected
    }
  }
}
</script>

<style lang="scss" src="./stylesheet/index.scss" />
